import { withMotion } from '../hoc/with-motion';
import { SearchResultPage } from '@/modules/player/components/search-result-page';

const AnimatedPage = withMotion(SearchResultPage);

export const roles: string[] = [];
export const path = '/player/search/:query';
export const element = <AnimatedPage />